import { pick, FlowHttpRequestOptions, mixHeadersOptions } from '@snfe/flow-yapi-helpers';
import * as model from '@/model';
import http from '../http';

/**
 * @desc id=1504672, catid=256704, projectId=41427, created=2025-01-13 14:22:42, last-modified=2025-02-20 16:58:56
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504672)
 */
export function postCommWebApiEvaluationPage(
  params: model.commWebApi.IPostCommWebApiEvaluationPageParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationPageResponse>('/commWebApi/evaluation/page', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['pageNum', 'pageSize', 'search', 'modality', 'source', 'type', 'openStatus', 'sortord']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504681, catid=256704, projectId=41427, created=2025-01-13 14:31:33, last-modified=2025-03-03 19:00:29
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504681)
 */
export function postCommWebApiEvaluationDetail(
  params: model.commWebApi.IPostCommWebApiEvaluationDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationDetailResponse>('/commWebApi/evaluation/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504670, catid=256704, projectId=41427, created=2025-01-13 14:13:18, last-modified=2025-02-20 16:59:00
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/home)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504670)
 */
export function postCommWebApiEvaluationHome(
  params: model.commWebApi.IPostCommWebApiEvaluationHomeParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationHomeResponse>('/commWebApi/evaluation/home', {
    data: pick(params, ['source']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504698, catid=256715, projectId=41427, created=2025-01-13 15:16:02, last-modified=2025-02-13 17:04:46
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/top)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504698)
 */
export function postCommWebApiModelRankTop(
  params: model.commWebApi.IPostCommWebApiModelRankTopParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankTopResponse>('/commWebApi/model/rank/top', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504699, catid=256715, projectId=41427, created=2025-01-13 15:18:33, last-modified=2025-02-14 17:00:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/dataList)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504699)
 */
export function postCommWebApiModelRankDataList(
  params: model.commWebApi.IPostCommWebApiModelRankDataListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankDataListResponse>('/commWebApi/model/rank/dataList', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504935, catid=256715, projectId=41427, created=2025-01-15 11:29:42, last-modified=2025-01-15 16:24:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/listDate)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504935)
 */
export function postCommWebApiModelRankListDate(
  params: model.commWebApi.IPostCommWebApiModelRankListDateParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankListDateResponse>('/commWebApi/model/rank/listDate', {
    data: pick(params, ['modality', 'modelType', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504708, catid=256715, projectId=41427, created=2025-01-13 15:21:06, last-modified=2025-01-23 15:44:20
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504708)
 */
export function postCommWebApiModelRankList(
  params: model.commWebApi.IPostCommWebApiModelRankListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankListResponse>('/commWebApi/model/rank/list', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504715, catid=256715, projectId=41427, created=2025-01-13 15:22:13, last-modified=2025-02-14 17:01:35
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504715)
 */
export function postCommWebApiModelRankDetail(
  params: model.commWebApi.IPostCommWebApiModelRankDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankDetailResponse>('/commWebApi/model/rank/detail', {
    data: pick(params, ['modelRankId', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504706, catid=256715, projectId=41427, created=2025-01-13 15:19:59, last-modified=2025-02-18 14:37:51
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/config/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504706)
 */
export function postCommWebApiModelRankConfigDetail(
  params: model.commWebApi.IPostCommWebApiModelRankConfigDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankConfigDetailResponse>('/commWebApi/model/rank/config/detail', {
    data: pick(params, ['modality', 'modelType', 'rankType', 'rankMonth']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504724, catid=256718, projectId=41427, created=2025-01-13 15:23:56, last-modified=2025-01-27 11:00:54
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/person/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504724)
 */
export function postCommWebApiPersonList(params: model.commWebApi.IPostCommWebApiPersonListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiPersonListResponse>('/commWebApi/person/list', {
    data: pick(params, ['onlyHomeShow', 'type']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504728, catid=256718, projectId=41427, created=2025-01-13 15:25:07, last-modified=2025-02-21 10:00:40
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/person/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504728)
 */
export function postCommWebApiPersonDetail(
  params: model.commWebApi.IPostCommWebApiPersonDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiPersonDetailResponse>('/commWebApi/person/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504730, catid=256720, projectId=41427, created=2025-01-13 15:26:20, last-modified=2025-01-20 14:34:37
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/organization/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504730)
 */
export function postCommWebApiOrganizationList(
  params: model.commWebApi.IPostCommWebApiOrganizationListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiOrganizationListResponse>('/commWebApi/organization/list', {
    data: pick(params, ['onlyHomeShow']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1505077, catid=256763, projectId=41427, created=2025-01-16 15:53:02, last-modified=2025-01-16 16:04:24
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/update)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1505077)
 */
export function postCommWebApiUserUpdate(params: model.commWebApi.IPostCommWebApiUserUpdateParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserUpdateResponse>('/commWebApi/user/update', {
    data: pick(params, ['newName', 'organization', 'sex', 'age', 'education', 'major', 'job', 'userType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1505069, catid=256763, projectId=41427, created=2025-01-16 15:50:55, last-modified=2025-01-20 14:18:14
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/me)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1505069)
 */
export function postCommWebApiUserMe(params: model.commWebApi.IPostCommWebApiUserMeParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserMeResponse>('/commWebApi/user/me', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519180, catid=258057, projectId=41427, created=2025-04-25 14:04:02, last-modified=2025-04-27 14:34:08
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/translation)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519180)
 */
export function postCommWebApiModelTranslation(
  params: model.commWebApi.IPostCommWebApiModelTranslationParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelTranslationResponse>('/commWebApi/model/translation', {
    data: pick(params, ['textList']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}
